import * as React from "react"

import { cn } from "@/lib/utils"

/**
 * Campo de captura. Alto 32px para caber en barras de filtro densas.
 * `aria-invalid` pinta el borde: la validacion no depende de leer el mensaje.
 */
const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-8 w-full rounded-md border border-input bg-surface px-2 py-1 text-sm text-foreground",
          "shadow-xs transition-[border-color,box-shadow] duration-100",
          "placeholder:text-muted-foreground/70",
          "hover:border-border-strong",
          "focus-visible:border-ring focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/35",
          "file:border-0 file:bg-transparent file:text-sm file:font-medium",
          "disabled:cursor-not-allowed disabled:bg-muted disabled:opacity-60",
          "aria-[invalid=true]:border-destructive aria-[invalid=true]:ring-destructive/25",
          className,
        )}
        ref={ref}
        {...props}
      />
    )
  },
)
Input.displayName = "Input"

export { Input }
